import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  signal,
} from '@angular/core';
import { ButtonComponent } from 'src/app/shared/components/button/button.component';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { DialogType } from '../../auth/interfaces/dialogTypes';

@Component({
  selector: 'app-about-modal-component',
  imports: [DialogComponent, ButtonComponent],
  templateUrl: './about-modal.component.html',
  styleUrl: './about-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutModalComponent implements OnInit {
  @Input() isDialogVisible: boolean = false; // Controls dialog visibility
  @Output() hide = new EventEmitter<void>(); // Emits when modal closes

  public dialogType: DialogType = DialogType.Simple;

  public basicInfoFields: { label: string; value: any }[] = [];
  public vehicleFields: { label: string; value: any }[] = [];
  currentYear = signal<number>(0);

  ngOnInit() {
    const currentDate = new Date();
    this.currentYear.set(currentDate.getFullYear());
  }

  public handleDialogClose(): void {
    this.isDialogVisible = false; // Hide the modal
    this.hide.emit(); // Notify parent about the closure
  }
}
